

import React, { useState, useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { AppBar, IconButton, Toolbar, Box, Typography, Switch, Select, alpha, Divider, Avatar, Menu, MenuItem, DialogContent, Dialog, Badge } from '@mui/material';
import { useTheme } from "@mui/material/styles";
import NotificationsNoneIcon from '@mui/icons-material/NotificationsNone';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import InputSelect from 'src/components/shared/Form/Select';
import SwitchComponent from 'src/components/shared/Form/Switch';
import ButtonComponent from 'src/components/shared/Button';
import { ReactComponent as SliderVerticalIcon } from '../../../assets/images/slider-vertical.svg';
import { ReactComponent as LeftArrow } from '../../../assets/images/arrow-left 2.svg';
import avatarImage from '../../../assets/images/avatar.jpg';
import RightSidebar from '../RIghtSidebar/RightSidebar';
import { useDispatch, useSelector } from 'react-redux';
import { setCurrentClinics, fetchAvailabilityRequest, getClinics, getDoctorProfileByIdRequest, postDoctorProfileRequest, postAvailabilityRequest, postProfilePicRequest, updateClinicByIdRequest, getClinicByIdRequest } from 'src/modules/app/store/appActions';
import { postNotification, getNotifications, updateNotification, getNotificationById, deleteNotification, getUsers } from 'src/modules/app/api/appApi';
import { useNavigate } from 'react-router-dom';
import { logout } from '../../../modules/auth/store/authActions';
import storage from 'src/utils/storageUtils';
import { components, palette, shadows, typography } from 'src/config/theme';
import { ReactComponent as Profile } from '../../../assets/images/profile-circle 2.svg';
import { ReactComponent as SettingIcon } from '../../../assets/images/setting-2.svg';
import { ReactComponent as Calendar } from '../../../assets/images/calendar.svg';
import { ReactComponent as CloseIcon } from '../../../assets/images/close-circle.svg';
import { ReactComponent as LogOut } from '../../../assets/images/logout.svg';
import { ReactComponent as Add } from '../../../assets/images/add-square.svg';
import { ReactComponent as PreviousIcon } from '../../../assets/images/arrow-left 2.svg';
import { getUserFromToken } from 'src/DecodeToken';
import DialogBox from 'src/components/shared/Dialog/DialogBox';
import CustomTabs from 'src/components/shared/CustomTabs/CustomTabs';
import { TabsContainer, HeaderPart, TabsData, ProfileContainer, ProfileAvatar, ProfileIcon, BoxContainer, FooterPart, SaveButton } from './Styles';
import LoginInfo from 'src/modules/app/components/DoctorProfile/DoctorProfileForms/LoginInfo';
import PersonalInfo from 'src/modules/app/components/DoctorProfile/DoctorProfileForms/PersonalInfo';
import ProfessionalInfo from 'src/modules/app/components/DoctorProfile/DoctorProfileForms/ProfessionalInfo';
import EducationInfo from 'src/modules/app/components/DoctorProfile/DoctorProfileForms/EducationInfo';
import Consulting from 'src/modules/app/components/DoctorProfile/DoctorProfileForms/Consulting';
import Photo from 'src/modules/app/components/DoctorProfile/DoctorProfileForms/Photo';
import FutureOption from 'src/modules/app/components/DoctorProfile/DoctorProfileForms/FutureOption';
import DoctorTiming from 'src/modules/app/components/DoctorProfile/DoctorProfileForms/DoctorTiming';
import SeoPurpose from 'src/modules/app/components/DoctorProfile/DoctorProfileForms/SeoPurpose';
import Links from 'src/modules/app/components/DoctorProfile/DoctorProfileForms/Links';
import useResponsive from 'src/components/hooks/useResponsive';
import GoogleCalendarIntegrationPage from 'src/modules/app/components/googleCalendar/GoogleCalendarIntegrationPage';
import logo from '../../../assets/images/logo.svg'
import ThankYou from 'src/modules/app/components/DoctorProfile/DoctorProfileForms/ThankYou';
import toast from 'src/utils/toast';

function Header({ isPermanentOpen }) {
  const theme = useTheme();
  const drawerWidth = 280;
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const [doctorProfileData, setDoctorProfileData] = useState({});
  const { isMobile, isTablet, isDesktop } = useResponsive();
  const clinic = useSelector((state) => state.app.clinics);
  const clinics = clinic?.data || [];
  const [anchorElUser, setAnchorElUser] = useState(null);
  const DoctorNameFromStorage = storage.get('DOCTORNAME');
  const user = useSelector((state) => state.auth.user);
  const DoctorName = user?.personalInfo?.fullName || DoctorNameFromStorage;
  const doctorId = getUserFromToken();
  const [openProfileDialog, setOpenProfileDialog] = useState(false);
  const [openCalendarDialog, setOpenCalendarDialog] = useState(false);
  const [selectedTab, setSelectedTab] = useState(0);
  const [isAcceptingTokens, setIsAcceptingTokens] = useState('');
  const [clinicDoctors, setClinicDoctors] = useState([]);

  const [doctorProfile, setDoctorProfile] = useState(null);
  const personalInfoRef = useRef();
  const loginInfoRef = useRef();
  const professionalInfoRef = useRef();
  const educationalInfoRef = useRef();
  const consultingInfoRef = useRef();
  const linkInfoRef = useRef();
  const futureInfoRef = useRef();
  const doctTimingInfoRef = useRef();
  const seoPurposeInfoRef = useRef();
  const doctId = getUserFromToken();
  const tabsData = [
    { label: "Personal Info" },
    { label: "Login Info" },
    { label: "Professional Info" },
    { label: "Educational Info" },
    { label: "Consulting" },
    { label: "Links" },
    { label: "Future Options" },
    { label: "Seo Purpose" },
    { label: "Doctor Timings" },
    { label: "Thank You" },
  ];

  const renderDoctorTabContent = () => {
    switch (selectedTab) {
      case 0: return <PersonalInfo data={doctorProfileData?.personalInfo || doctorProfile?.personalInfo} innerRef={personalInfoRef} setDoctorProfileData={setDoctorProfileData} />;
      case 1: return <LoginInfo data={doctorProfileData?.loginInfo || doctorProfile?.loginInfo} innerRef={loginInfoRef} setDoctorProfileData={setDoctorProfileData} />;
      case 2: return <ProfessionalInfo data={doctorProfileData?.professionalInfo || doctorProfile?.professionalInfo} innerRef={professionalInfoRef} setDoctorProfileData={setDoctorProfileData} />;
      case 3: return <EducationInfo data={doctorProfileData?.educationalInfo || doctorProfile?.educationalInfo} innerRef={educationalInfoRef} setDoctorProfileData={setDoctorProfileData} />;
      case 4: return <Consulting data={doctorProfileData?.consulting || doctorProfile?.consulting} innerRef={consultingInfoRef} setDoctorProfileData={setDoctorProfileData} />;
      case 5: return <Links data={doctorProfileData?.links || doctorProfile?.links} innerRef={linkInfoRef} setDoctorProfileData={setDoctorProfileData} />;
      case 6: return <FutureOption data={doctorProfileData?.futureOptions || doctorProfile?.futureOptions} innerRef={futureInfoRef} setDoctorProfileData={setDoctorProfileData} />;
      case 7: return <SeoPurpose data={doctorProfileData?.seoPurpose || doctorProfile?.seoPurpose} innerRef={seoPurposeInfoRef} setDoctorProfileData={setDoctorProfileData} />;
      case 8: return <DoctorTiming data={doctorProfileData?.doctorTimings || doctorProfile?.doctorTimings} innerRef={doctTimingInfoRef} setDoctorProfileData={setDoctorProfileData} />;
      case 9: return <ThankYou />;
      default: return null;
    }
  };




  const handleLogout = () => {
    dispatch(logout());
    navigate('/auth/login');
  };

  const formikRefs = [personalInfoRef, loginInfoRef, professionalInfoRef, educationalInfoRef, consultingInfoRef, linkInfoRef, futureInfoRef, seoPurposeInfoRef, doctTimingInfoRef];

  const handleNext = async () => {
    const currentRef = formikRefs[selectedTab];
    if (currentRef?.current?.submitForm) {
      await currentRef.current.submitForm();
    }
    await new Promise((resolve) => setTimeout(resolve, 100));
    if (currentRef?.current?.isValid === false) return;

    if (selectedTab === tabsData.length - 1) {
      const updatedProfileData = {
        ...doctorProfileData,
        id: doctId,
      };
      console.log("all data", updatedProfileData);

      try {
        const response = await new Promise((resolve, reject) => {
          dispatch(postDoctorProfileRequest(updatedProfileData, resolve, reject));
          setOpenProfileDialog(false);
        });
        if (response) {
          dispatch(getDoctorProfileByIdRequest(doctId, (res) => {
            setDoctorProfile(res);
          }));
        }
      } catch (error) {
        console.error("Error saving doctor profile:", error);
        toast.error(error?.message || error?.error || "Failed to save doctor profile");
      }
    } else {
      setSelectedTab((prev) => prev + 1);
    }
  };



  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await new Promise((resolve, reject) => {
          dispatch(getDoctorProfileByIdRequest(doctId, resolve, reject));
        });
        if (response) {
          setDoctorProfile(response);
          console.log("my doctor profile", response);
        }
      } catch (err) {
        console.warn('Doctor profile not available:', err?.message || err);
      }
    };
    fetchData();
  }, [doctId, dispatch]);



  const clinicList = (clinics || []).map((clinic) => ({
    ...clinic,
    label: clinic.clinicName,
    value: clinic.id,
  }));

  useEffect(() => {
    if (!clinic?.data || clinic.data.length === 0) {
      dispatch(getClinics());
    }
  }, []);

  const pathParts = location.pathname.split('/');
  const activeDoctorId = pathParts.length >= 3 ? pathParts[2] : doctorId;

  const doctorList = clinicDoctors.length > 0
    ? clinicDoctors.map((doc) => ({
      label: doc.fullName,
      value: doc.id,
    }))
    : [{ label: DoctorName, value: doctorId }];

  const setDoctorIdOnUrl = (id) => {
    const currentPath = location.pathname;
    const parts = currentPath.split('/');
    if (parts.length >= 3 && parts[1] === clinic.currentClinic?.id) {
      parts[2] = id;
      const newPath = parts.join('/');
      navigate(newPath);
    } else {
      navigate(`/${clinic.currentClinic?.id}/${id}/dashboard`);
    }
  };

  useEffect(() => {
    if (clinic.currentClinic?.id) {
      dispatch(getClinicByIdRequest(clinic.currentClinic.id, (res) => {
        if (res?.doctors && Array.isArray(res.doctors)) {
          setClinicDoctors(res.doctors);
        } else {
          setClinicDoctors([]);
        }
      }, (err) => {
        console.warn('[Header] Failed to fetch clinic doctors:', err);
        setClinicDoctors([]);
      }));
    }
  }, [clinic.currentClinic?.id, dispatch]);

  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };
  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  const settings = [
    {
      label: 'Profile',
      icon: <Profile width={22} />,
      action: () => setOpenProfileDialog(true),
    },
    // {
    //   label: 'Settings',
    //   icon: <SettingIcon width={22} />,
    //   action: () => console.log('Account Clicked'),
    // },
    {
      label: 'Connect Calendar',
      icon: <Calendar width={22} />,
      action: () => {
        console.log("Opening calendar dialog...");
        setOpenCalendarDialog(true);
      }
    },
    {
      label: 'Logout',
      icon: <LogOut width={22} />,
      action: () => handleLogout(),
    }
  ];

  const navigateAfterClinicSwitch = (clinicId, docId) => {
    const currentPath = location.pathname;
    const parts = currentPath.split('/');
    if (parts.length >= 3) {
      parts[1] = clinicId;
      parts[2] = docId;
      const newPath = parts.join('/');
      navigate(newPath);
    } else {
      navigate(`/${clinicId}/${docId}/dashboard`);
    }
  };

  const setClinicIdOnUrl = (id) => {
    const selectedClinic = clinicList.find((clinic) => clinic.id === id);
    if (selectedClinic) {
      dispatch(setCurrentClinics({ clinicId: selectedClinic.id, doctorId: doctorId }));
      dispatch(getClinicByIdRequest(selectedClinic.id, (res) => {
        let targetDocId = doctorId;
        if (res?.doctors && res.doctors.length > 0) {
          setClinicDoctors(res.doctors);
          targetDocId = res.doctors[0].id;
        } else {
          setClinicDoctors([]);
        }
        navigateAfterClinicSwitch(selectedClinic.id, targetDocId);
      }, (err) => {
        console.warn('[Header] Failed to fetch clinic doctors on clinic switch:', err);
        setClinicDoctors([]);
        navigateAfterClinicSwitch(selectedClinic.id, doctorId);
      }));
    }
  };

  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [selectValue, setSelectValue] = useState('');
  const handleChange = (value) => {
    setSelectValue(value);
    console.log("Selected Value:", value);
  };
  const isFirstLoad = useRef(true);
  // Fetch availability on mount
  useEffect(() => {
    if (clinic.currentClinic?.id) {
      dispatch(
        fetchAvailabilityRequest(
          clinic.currentClinic.id,
          (res) => {
            const tokenStatus = res?.clinicSettings?.acceptingTokens === 'yes';
            setIsAcceptingTokens(tokenStatus);
            isFirstLoad.current = false;
          },
          (err) => {
            console.error("Error fetching availability", err);
          }
        )
      );
    }
  }, [clinic.currentClinic?.id]);


  const handleToggle = () => {
    const updatedValue = !isAcceptingTokens;
    setIsAcceptingTokens(updatedValue);

    console.log("Clinic toggle clicked. New value:", updatedValue);

    const clinicId = clinic.currentClinic?.id;

    if (updatedValue) {
      toast.success("Clinic is now Opened");
    } else {
      toast.error("Clinic is now Closed");
    }

    if (clinicId) {
      const updateData = {
        clinicId: clinicId,
        acceptingTokens: updatedValue ? 'yes' : 'no'
      };

      dispatch(postAvailabilityRequest({
        data: updateData,
        resolve: (res) => {
          console.log("Clinic availability updated successfully", res);
        },
        reject: (err) => {
          console.error("Error updating clinic availability", err);
          toast.error(err.message || "Failed to update clinic status on server");
        }
      }));
    }
  };

  const fileInputRef = useRef();
  const [logoPreview, setLogoPreview] = useState(null);

  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (!file || !doctorId) return;

    const previewUrl = URL.createObjectURL(file);
    setLogoPreview(previewUrl);

    const formData = new FormData();
    formData.append("userId", doctorId);
    formData.append("profilePic", file);

    for (let pair of formData.entries()) {
      console.log(`${pair[0]}:`, pair[1]);
    }

    try {
      const response = await new Promise((resolve, reject) => {
        dispatch(postProfilePicRequest(formData, resolve, reject));
      });
      console.log('Logo upload response:', response);

    } catch (error) {
      console.error('Failed to upload logo:', error);
      console.log("on Error:", error.message);
    }
  };

  const baseUrl = process.env.REACT_APP_BASE_API_URL || '';
  const profilePic = doctorProfile?.personalInfo?.profilePic;
  const avatarSrc = logoPreview || (profilePic && !profilePic.startsWith('no ') ? (profilePic.startsWith('http') ? profilePic : `${baseUrl}${profilePic.startsWith('/') ? '' : '/'}${profilePic}`) : null);

  const [notifCount, setNotifCount] = useState(0);
  const [anchorElNotif, setAnchorElNotif] = useState(null);
  const [notifications, setNotifications] = useState([]);
  const [notifLoading, setNotifLoading] = useState(false);
  const [notifPage, setNotifPage] = useState(1);
  const notifLimit = 10;

  const appOrigin = window.location.origin;
  const normalizeNotificationUrl = (u) => {
    try {
      const trimmed = (u || '').trim();
      if (!trimmed) return null;
      if (/^https?:\/\//i.test(trimmed)) {
        const parsed = new URL(trimmed);
        const suffix = parsed.pathname + parsed.search + parsed.hash;
        return `${appOrigin}${suffix}`;
      }
      if (trimmed.startsWith('/')) return `${appOrigin}${trimmed}`;
      try {
        const relParsed = new URL(trimmed, 'http://placeholder');
        if (relParsed && relParsed.hostname) {
          const suffix = relParsed.pathname + relParsed.search + relParsed.hash;
          return `${appOrigin}${suffix}`;
        }
      } catch { }
      return `${appOrigin}/${trimmed}`;
    } catch {
      return appOrigin;
    }
  };

  const fetchNotifications = async (page = 1) => {
    try {
      setNotifLoading(true);
      const res = await getNotifications({ params: { page, limit: notifLimit } });
      const list = res?.data || [];
      setNotifications(list);
      setNotifCount(list.length);
    } catch (err) {
      const msg = err?.message || 'Failed to fetch notifications';
      toast.error(msg);
    } finally {
      setNotifLoading(false);
    }
  };

  const handleOpenNotifications = async (event) => {
    setAnchorElNotif(event.currentTarget);
    await fetchNotifications(1);
  };
  const handleCloseNotifications = () => setAnchorElNotif(null);
  const handleNotificationClick = async (n) => {
    try {
      const detail = await getNotificationById(n.id);
      const item = detail?.notification || n;
      await updateNotification(item.id, { notificationStatus: 'check' });
      setNotifications((prev) => prev.map((x) => (x.id === item.id ? { ...x, notificationStatus: 'check' } : x)));
      if (item.url) {
        const target = normalizeNotificationUrl(item.url);
        if (target) window.open(target, '_blank');
      }
      handleCloseNotifications();
      toast.success('Notification updated successfully');
    } catch (err) {
      const msg = err?.message || 'Failed to update notification';
      toast.error(msg);
    }
  };
  const handleNotificationDelete = async (e, n) => {
    e.stopPropagation();
    try {
      const res = await deleteNotification(n.id);
      const updated = notifications.filter((x) => x.id !== n.id);
      setNotifications(updated);
      setNotifCount(updated.length);
      toast.success(res?.message || 'Notification deactivated successfully');
    } catch (err) {
      const msg = err?.message || 'Failed to delete notification';
      toast.error(msg);
    }
  };

  React.useEffect(() => {
    const onCreated = () => {
      fetchNotifications(1);
    };
    window.addEventListener('app:notificationCreated', onCreated);
    return () => window.removeEventListener('app:notificationCreated', onCreated);
  }, []);

  return (
    <>
      <AppBar sx={{
        position: 'fixed',
        bgcolor: theme.palette.gery.white,
        paddingX: isMobile || isTablet ? '20px' : 2,
        boxShadow: "none",
        borderBottom: '1px solid #0000001A',
        height: isMobile || isTablet ? '72px' : '84px',
        display: 'flex',
        justifyContent: 'center',
        width: {
          xs: '100%',
          sm: '100%',
          md: isPermanentOpen ? `calc(100% - ${drawerWidth}px)` : 'calc(100% - 90px)',
        },
      }} disableGutters>
        <Toolbar disableGutters>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%', alignItems: 'center' }} >
            <Box sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              gap: '16px'
            }}>
              {isDesktop && location.pathname.includes('/appointment/Patients/') && (
                <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer' }} onClick={() => navigate(`${clinic.currentClinic?.id}/${doctorId}/appointment`)}>
                  <IconButton sx={{ marginRight: '10px' }}>
                    <LeftArrow width={24} height={24} />
                  </IconButton>
                  <Typography variant="h5" color="black" sx={{ marginLeft: '-20px' }}>Back</Typography>
                </Box>
              )}
              {(isMobile || isTablet) && (
                <img src={logo} alt="Logo" style={{ height: '40px', width: '142px' }} />
              )}

              <InputSelect
                showNone={false}
                value={clinic.currentClinic?.id || clinics[0]?.id}
                options={clinicList}
                onChange={(selectedValue) => setClinicIdOnUrl(selectedValue)}
                variant="outlined"
                placeholder="Choose"
                sx={{
                  width: { xs: '126px', md: '150px', lg: '200px' },
                  boxShadow: theme.shadows[1],
                  '& .MuiOutlinedInput-root': {
                    height: isMobile || isTablet ? '44px' : '52px',
                    display: 'flex',
                    alignItems: 'center',
                    borderRadius: '12px',
                  },
                }}
              />

              {isDesktop && (
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    border: `1px solid ${alpha(theme.palette.gery.black, 0.14)}`,
                    borderRadius: '12px',
                    padding: { xs: '10px 12px', lg: '10px 18px' },
                    width: { xs: 'auto', md: '180px', lg: '238px' },
                    height: '52px',
                    boxShadow: theme.shadows[1],
                  }}
                >
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px', width: '100%', justifyContent: 'space-around' }}>
                    <Typography variant={theme.typography.h5} color="black" sx={{ textWrap: 'nowrap', display: { xs: 'none', lg: 'block' } }}>
                      Clinic: Close
                    </Typography>
                    <Typography variant={theme.typography.h5} color="black" sx={{ textWrap: 'nowrap', display: { xs: 'block', lg: 'none' } }}>
                      Close
                    </Typography>
                    <SwitchComponent
                      value={isAcceptingTokens}
                      onChange={handleToggle}
                      sx={{
                        margin: 0,
                        padding: 0,
                      }}
                    />
                    <Typography variant={theme.typography.h5} color="black" sx={{ textWrap: 'nowrap' }}>
                      Open
                    </Typography>
                  </Box>
                </Box>
              )}

            </Box>
            <Box sx={{
              // width: '409px',
              height: '52px', display: 'flex', alignItems: 'center', gap: '20px'
            }}>

              {isDesktop && (
                <>
                  <ButtonComponent
                    variant="outlined"
                    onClick={() => setSidebarOpen(true)}
                    startIcon={<SliderVerticalIcon width={24} height={24} sx={{ color: theme.palette.primary.main }} />}
                    sx={{ width: '160px', height: '52px', borderRadius: '12px', padding: '10px', bgcolor: theme.palette.primary.light3, border: `1px solid ${theme.palette.primary.light1}` }}>OPD Queue
                  </ButtonComponent>
                  <Divider orientation='vertical' />
                </>

              )}

              <IconButton aria-label="notifications" onClick={handleOpenNotifications} sx={{ color: palette.primary.main }}>
                <Badge color="error" overlap="circular" badgeContent={notifCount} max={99}>
                  <NotificationsNoneIcon />
                </Badge>
              </IconButton>

              <Menu
                PaperProps={{
                  sx: {
                    backgroundColor: palette.gery.white,
                    boxShadow: shadows[4],
                    borderRadius: '12px',
                    border: `1px solid ${alpha(theme.palette.gery.black, 0.14)}`,
                    width: 360,
                    maxHeight: 420,
                  },
                }}
                sx={{ mt: '45px' }}
                anchorEl={anchorElNotif}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                open={Boolean(anchorElNotif)}
                onClose={handleCloseNotifications}
              >
                <Box sx={{ px: 2, py: 1 }}>
                  <Typography variant={theme.typography.h3} sx={{ color: palette.gery.black }}>
                    Notifications
                  </Typography>
                </Box>
                <Divider />
                <Box sx={{ maxHeight: 320, overflowY: 'auto' }}>
                  {notifLoading ? (
                    <Typography sx={{ p: 2, color: alpha(palette.gery.black, 0.7) }}>Loading...</Typography>
                  ) : notifications.length === 0 ? (
                    <Typography sx={{ p: 2, color: alpha(palette.gery.black, 0.7) }}>No notifications</Typography>
                  ) : (
                    notifications.map((n) => (
                      <MenuItem
                        key={n.id}
                        onClick={() => handleNotificationClick(n)}
                        sx={{ alignItems: 'flex-start', whiteSpace: 'normal' }}
                      >
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', width: '100%', gap: 1 }}>
                          <Box>
                            <Typography variant="body1" sx={{ color: palette.gery.black }}>
                              {n.message}
                            </Typography>
                            {n.createdAt && (
                              <Typography variant="caption" sx={{ color: alpha(palette.gery.black, 0.6) }}>
                                {new Date(n.createdAt).toLocaleString()}
                              </Typography>
                            )}
                          </Box>
                          <IconButton size="small" onClick={(e) => handleNotificationDelete(e, n)}>
                            <DeleteOutlineIcon fontSize="small" />
                          </IconButton>
                        </Box>
                      </MenuItem>
                    ))
                  )}
                </Box>
              </Menu>

              <Box sx={{
                width: 'auto',
                height: '52px',
                display: 'flex', gap: '10px',
                alignItems: 'center',
              }} onClick={handleOpenUserMenu}>
                <Avatar
                  src={avatarSrc || ''}
                  sx={{
                    width: isMobile || isTablet ? '40px' : '52px',
                    height: isMobile || isTablet ? '40px' : '52px',
                    backgroundColor: palette.primary.light2,
                    color: palette.primary.main
                  }}
                >
                  {!avatarSrc && (DoctorName?.charAt(0).toUpperCase() || '')}
                </Avatar>

                {isDesktop && (
                  <Box sx={{ pr: 1.5, display: { xs: 'none', lg: 'block' } }}>
                    <Typography variant={theme.typography.h3} color={theme.palette.gery.black} sx={{ textWrap: 'nowrap', pr: 1 }}>
                      {DoctorName}
                    </Typography><br />
                    <Typography variant={theme.typography.smallRegular} color={`${alpha(theme.palette.gery.black, 0.698)}`}>
                      as an Owner
                    </Typography>
                  </Box>
                )}

              </Box>

              <Menu
                PaperProps={{
                  sx: {
                    backgroundColor: palette.gery.white,
                    boxShadow: shadows[4],
                    borderRadius: '12px',
                    border: `1px solid ${alpha(theme.palette.gery.black, 0.14)}`,
                    minWidth: '200px',
                  },
                }}
                sx={{
                  mt: '45px',
                }}
                id="menu-appbar"
                anchorEl={anchorElUser}
                anchorOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                keepMounted
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                open={Boolean(anchorElUser)}
                onClose={handleCloseUserMenu}
              >
                {settings.map((setting) => (
                  <MenuItem key={setting.label} onClick={() => {
                    handleCloseUserMenu();
                    setting.action();
                  }}>
                    <Typography variant='h65' sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>{setting.icon}{setting.label}</Typography>
                  </MenuItem>
                ))}
              </Menu>
            </Box>
          </Box>
        </Toolbar>
        <RightSidebar open={sidebarOpen} onClose={() => setSidebarOpen(false)} />
      </AppBar>
      <DialogBox open={openProfileDialog} PaperProps={{
        // sx: {
        //   maxWidth: 'none',
        // }
      }}>
        <HeaderPart>
          Doctor Profile
          <CloseIcon width={isMobile || isTablet ? 18 : 24}
            height={isMobile || isTablet ? 18 : 24} onClick={() => setOpenProfileDialog(false)} style={{ cursor: 'pointer' }} />
        </HeaderPart>
        <DialogContent sx={{ pl: 0, pr: 0, pb: 0 }}>
          <BoxContainer>
            <ProfileContainer>
              <ProfileAvatar src={avatarSrc}>
                {
                  !avatarSrc &&
                  (doctorProfile?.personalInfo?.fullName?.[0]?.toUpperCase() || 'D')
                }
              </ProfileAvatar>
              <ProfileIcon onClick={() => fileInputRef.current.click()}>
                <Add width="18px" height="18px" />
              </ProfileIcon>

              <input
                type="file"
                accept="image/*"
                ref={fileInputRef}
                onChange={handleFileChange}
                style={{ display: 'none' }}
              />

            </ProfileContainer>
          </BoxContainer>
          <TabsContainer>
            <CustomTabs
              value={selectedTab}
              tabs={tabsData}
              onChange={(index) => setSelectedTab(index)}
              sx={{

                tabStyles: {
                  color: `${alpha(palette.gery.black, 0.7)}`,
                  selectedColor: palette.primary.main,
                  height: "56px",
                  // fontSize: '17px',
                  // fontWeight: '400px',
                  // lineHeight: '21.62px'

                },
                indicatorStyles: {
                  color: palette.primary.main,
                  height: "2px",
                },
              }}
            />

          </TabsContainer>
          <TabsData sx={
            selectedTab === tabsData.length - 1
              ? {
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'

              }
              : {}
          } >
            {renderDoctorTabContent()}
          </TabsData>
        </DialogContent>
        <FooterPart >
          {selectedTab > 0 && (
            <ButtonComponent
              variant="none"
              startIcon={<PreviousIcon width={isMobile || isTablet ? '18px' : '24px'} height={isMobile || isTablet ? '18px' : '24px'} sx={{ color: palette.primary.main, ...(isMobile ? theme.typography.h6 : {}) }} />}
              onClick={() => setSelectedTab(prev => prev - 1)}
            >
              Previous
            </ButtonComponent>
          )}
          <SaveButton
            type="submit"
            variant="outlined"
            startIcon={<Add width={isMobile || isTablet ? '18px' : '24px'} height={isMobile || isTablet ? '18px' : '24px'} sx={{ color: palette.primary.main }} />}
            onClick={handleNext}
          >
            {selectedTab === tabsData.length - 1 ? 'Submit' : 'Next'}
          </SaveButton>
        </FooterPart>

      </DialogBox>

      <Dialog
        open={openCalendarDialog}
        onClose={() => setOpenCalendarDialog(false)}
      >
        <GoogleCalendarIntegrationPage onClose={() => setOpenCalendarDialog(false)} />
      </Dialog>

    </>

  )
}
export default Header;

